import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import icon from '../../assets/icon_edit.svg';

interface TestInfo {
  id: string;
  title: string;
  description: string;
  path: string;
}

interface LatestTestResults {
  [testType: string]: {
    createdAt: string;
  };
}

interface UserTestHistoryProps {
  tests: TestInfo[];
  latestResults: LatestTestResults;
  formatLastTestedDate: (testId: string) => string;
}

const UserTestHistory: React.FC<UserTestHistoryProps> = ({
  tests,
  latestResults,
  formatLastTestedDate,
}) => {
  return (
    <section className="setting-section">
      <div className="section-header">
        <h2>심리 검사</h2>
        <Link to="/tests" className="edit-link">
          <img src={icon} alt="검사하기" />
          <p>검사하기</p>
        </Link>
      </div>
      <div className="test-list-profile">
        {tests
          .filter(test => latestResults[_.get(test, 'id')])
          .map(test => ( 
            <Link
              to={`/tests/${_.get(test, 'id')}/history`}
              key={_.get(test, 'id')}
              className="test-card-profile"
            >
              <h3>{_.get(test, 'title')}</h3>
              <p>{_.get(test, 'description')}</p>
              <div className="test-card__footer">
                <span>{formatLastTestedDate(_.get(test, 'id'))}</span>
                <span>결과 보기 →</span>
              </div>
            </Link>
          ))}
      </div>
    </section>
  );
};

export default UserTestHistory;
